import React from 'react';

interface MarginBarProps {
  margin: number;
}

export function MarginBar({ margin }: MarginBarProps) {
  let color: string;
  if (margin >= 50) {
    color = 'var(--color-success)';
  } else if (margin >= 20) {
    color = 'var(--color-warning)';
  } else {
    color = 'var(--color-error)';
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
      <div
        style={{
          width: '100%',
          height: 6,
          background: color,
          borderRadius: 'var(--radius-xs)',
        }}
      />
      <div style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)' }}>
        Margine: <span style={{ fontWeight: 600, color }}>{margin.toFixed(0)}%</span>
      </div>
    </div>
  );
}
